function isUat() {
    let hostname = window.location.hostname;
    return ((hostname.includes("localhost")) || (hostname.includes("uat")));
}

module.exports = {
	isUat() {
		return isUat();
	},
	setting: isUat() ?
	{
		// UAT setting
		baseURL: "https://uat.api.oshmi.nexsoftech.com",
		stripePublishableKey: "pk_test_51JL3lhClDBy6uSg4z8Jlehx1llHBqQPtxipHXYEzX40Eztd6XrdjMQA8KdMwO8ls7SHWJpr1rVANJdHn1SnDR9po00ypwobauf",
	} :
	{
		// PRD setting
		baseURL: "https://api.oshmi.org",
		stripePublishableKey: "pk_live_51JL3lhClDBy6uSg4S7XCwvCXqRLLPn11bv8lJG3KUk8gz6SKzrEwqzwRDFgsO3PsdzCHGWJkC86tDS13OwNO7L7F00J2fvpx6j",
	},
        
	getToken() {
		var cookieArr = document.cookie.split(";");
		for(var i = 0; i < cookieArr.length; i++) {
			var cookiePair = cookieArr[i].split("=");

			if('oshmiUserToken' == cookiePair[0].trim()) {
				return decodeURIComponent(cookiePair[1]);
			}
		}
		return false;
	},
}
